import React from 'react';
import cx from 'classnames';

import { wordpressImgToImgixURL } from 'Utilities';
import { LANDING_PAGE_EVENTS, LANDING_PAGE_SECTIONS_NAMES } from 'Utilities/analytics';

import { Content } from 'LegacySBCRA/Content/Content';

import ResponsiveImage from '../../../../../components/misc/ResponsiveImage/ResponsiveImage';
import { usePageRefEvents } from '../../../common/Hooks/usePageRefEvents';
import { SEOContentBlock } from '../SEOContentBlocks/SEOContentBlock';

import styles from './HowToSell.scss';

type Props = {
  acf: Record<string, string>;
}

export const HowToSell = ({ acf }: Props) => {
  const titles = {
    readyToSellTitle: acf?.section_two_title,
    sellCarTitle: acf?.video_section_title,
    whyMotorwayTitle: acf?.section_one_title,
  } as const;

  const contentData = [
    {
      className: styles.topCard,
      contentBody: acf?.video_section_body_area,
      id: 1,
      imgSrc: (
        acf?.video_section_thumbnail ? <ResponsiveImage
          imgProps={{
            alt: acf?.video_section_alt,
            height: 440,
            loading: 'lazy',
            width: 440,
          }}
          imgSrc={wordpressImgToImgixURL(acf?.video_section_thumbnail)}
        /> : null
      ),
      isVideo: true,
      title: titles.sellCarTitle,
      vidSrc: acf?.video_section_source,
    } as const,
    {
      contentBody: acf?.section_one_body_area,
      id: 2,
      theme: 'blue',
      title: titles.whyMotorwayTitle,
    } as const,
    {
      contentBody: acf?.section_two_body_area,
      id: 3,
      title: titles.readyToSellTitle,
    } as const,
  ];

  const eventLabels = contentData.map((content) => content.title);
  const onSectionLoad = (label: string) => LANDING_PAGE_EVENTS.SECTION_LOAD({
    label,
    name: LANDING_PAGE_SECTIONS_NAMES.SEO,
  });

  const {
    $wrapper,
    entryMap: eventMap,
    setRef: setHowToSellSectionRef,
  } = usePageRefEvents({
    eventLabels,
    onRefTrigger: (label?: string) => onSectionLoad(label || ''),
  });

  const setHowToSellContentRef:<T extends Element>(node: T, index: number) => void = (ref, index) => {
    const entry = eventMap.get(eventLabels[index]);
    if (!entry?.isIntersecting) {
      setHowToSellSectionRef(ref, index);
    }
  };

  return (
    <Content className={styles.component} wrapper={{ className: cx(styles.componentWrapper) }}>
      <div ref={$wrapper} className={cx(styles.componentSection, { [styles.singleColumn]: acf?.single_column_boxes })}>
        {contentData.map((content, index) => (
          <SEOContentBlock
            key={content.id}
            ref={(ref) => ref && setHowToSellContentRef(ref, index)}
            data-seo-content
            {...content}
          />
        ))}
      </div>
    </Content>
  );
};
